import {
  getNestedStateObject
} from '@/utils';

export default {
  fieldValue: state => data => {
    return getNestedStateObject(state, [...data.vuexPath, 'fields', data.name, 'value']);
  },

  showFieldError: state => data => {
    const fieldData = getNestedStateObject(state, [...data.vuexPath, 'fields', data.name]);
    const formData = getNestedStateObject(state, data.vuexPath);
    const hasServerBookingMsg = fieldData?.serverBookingError === true;
    return !!(fieldData && formData && fieldData.error && (fieldData.userHasTyped || formData.hasBeenSubmitted || hasServerBookingMsg));
  },

  /** true whenever the field's current value is non-empty and passes validation, regardless of touch */
  showFieldSuccess: state => data => {
    const fieldData = getNestedStateObject(state, [...data.vuexPath, 'fields', data.name]);
    const hasValue = fieldData && fieldData.value !== '' && fieldData.value !== null && typeof fieldData.value !== 'undefined';

    return !!(fieldData && hasValue && !fieldData.error);
  },

  fieldErrorMessage: state => data => {
    const errorMessage = getNestedStateObject(state, [...data.vuexPath, 'fields', data.name, 'message']);

    // check if the field has a validationMessage from HTML5 API (and is not a radio button)
    if (!errorMessage && data.target && !Array.isArray(data.target) && data.target.validationMessage) {
      return data.target.validationMessage;
    }
    return errorMessage;
  },

  /** loop form fields and check all are valid */
  formIsValid: (state, getters) => data => {
    let formData = data;
    if (Array.isArray(data)) {
      formData = getNestedStateObject(state, data);
    }

    // ensure the formData is there to check
    // otherwise assume its not setup yet and fail validation
    if (!formData) {
      return false;
    }

    for (const fieldName in formData.fields) {
      if (formData.fields[fieldName].error) {
        return false;
      }
    }

    // validate address if necessary
    if (formData.address && formData.address.fields) {
      if (!getters.formIsValid(formData.address) || !getters.formIsValid(formData.address.fields.addressLines)) {
        return false;
      }
    }

    return true;
  },

  /** get a flat version of form data in key:value pairs (also handles nesting) */
  formDataFlat: state => data => {
    let formData = data;
    if (Array.isArray(data)) {
      formData = getNestedStateObject(state, data);
    }

    const addFieldsToObject = (object, data) => {
      if (data && data.fields) {
        for (const fieldName in data.fields) {

          // handle nested objects
          if (data.fields[fieldName].fields) {
            object[fieldName] = {};
            addFieldsToObject(object[fieldName], data.fields[fieldName]);
          } else {
            object[fieldName] = data.fields[fieldName].value;
          }
        }

        // add address data to form data if necessary
        if (data.address) {
          object.address = {};
          addFieldsToObject(object.address, data.address);
        }
      }
    }

    const flat = {};
    addFieldsToObject(flat, formData);
    return flat;
  },

  /** check whether a form has been submitted */
  formHasBeenSubmitted: (state) => vuexPath => {
    const data = getNestedStateObject(state, vuexPath);
    return data ? data.hasBeenSubmitted : false;
  },

  /** get passenger full name and title */
  passengerFullName: () => (passenger, { showLeadTag = false } = {}) => {  
    const name = [];  
  
    ['firstName', 'lastName'].forEach(part => {    
      if (passenger[part]) {      
        name.push(passenger[part]);    
      }  
    });  
  
    let fullName = name.join(' ');  
  
    if (showLeadTag && passenger.lead) { 
      fullName += ' (Lead)'; 
    }  
  
    return fullName;
  },

  /** get customer full name and title */
  customerFullName: () => (customer, { showLeadTag = false } = {}) => {  
    const name = [];  
  
    ['legalFirstName', 'legalLastName'].forEach(part => {    
      if (customer.name && customer.name[part]) {
        name.push(customer.name[part]);
      }
    });  
  
    let fullName = name.join(' ');  
  
    if (showLeadTag && customer.lead) { 
      fullName += ' (Lead)'; 
    }  
  
    return fullName;
  }
}